module.exports = __webpack_public_path__ + "static/media/icon-studio3marketing.6099c157.svg";